var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5417 19.9375C5.3625 19.9375 1.14583 15.7208 1.14583 10.5417C1.14583 5.3625 5.3625 1.14583 10.5417 1.14583C15.7208 1.14583 19.9375 5.3625 19.9375 10.5417C19.9375 15.7208 15.7208 19.9375 10.5417 19.9375ZM10.5417 2.52083C6.11417 2.52083 2.52083 6.12333 2.52083 10.5417C2.52083 14.96 6.11417 18.5625 10.5417 18.5625C14.9692 18.5625 18.5625 14.96 18.5625 10.5417C18.5625 6.12333 14.9692 2.52083 10.5417 2.52083Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.1667 20.8542C19.9925 20.8542 19.8183 20.79 19.6808 20.6525L17.8475 18.8192C17.5817 18.5533 17.5817 18.1133 17.8475 17.8475C18.1133 17.5817 18.5533 17.5817 18.8192 17.8475L20.6525 19.6808C20.9183 19.9467 20.9183 20.3867 20.6525 20.6525C20.515 20.79 20.3408 20.8542 20.1667 20.8542Z",
    fill: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3a65aa2b8418622608b9371808725f0a.svg";
export { ForwardRef as ReactComponent };